import {
  trackClubImportNudge,
  trackClubImportNudgeAction,
} from "@/events/clubImportMixpanel";
import { useClubImportNudgeTracking as useShared } from "@repo/shared/hooks";
import type { ClubImportNudgeId } from "@repo/shared/redux";

/*
  Web's binding of the shared nudge-tracking hook. Same split as
  useCreditDialogTracking: the latch is shared so both apps report one funnel,
  only the transport differs, and web's analytics port is a deliberate no-op.
*/
const WEB_TRACKERS = {
  onShown: trackClubImportNudge,
  onExit: trackClubImportNudgeAction,
};

export const useClubImportNudgeTracking = (
  nudgeId: ClubImportNudgeId,
  origin: { section: string; subsection?: string },
) => useShared(nudgeId, origin, WEB_TRACKERS);
